import { apiRequest } from '../services/apiService';
import type { ExpenseReceipt } from './expenseReceipts';

export async function listReimbursementReceipts(eventId: string, reimbursementId: string) {
  const { response, error } = await apiRequest({ method: 'GET', url: 'reimbursement-receipts', isToken: true, params: { eventId, reimbursementId } });
  if (error || !response) throw error || new Error('Unable to load reimbursement receipts');
  return { rows: (Array.isArray(response.data?.data) ? response.data.data : []) as ExpenseReceipt[], canUpload: response.data?.permissions?.canUpload === true };
}
export async function uploadReimbursementReceipt(eventId: string, reimbursementId: string, file: File, requestId: string) {
  const data = new FormData(); data.append('file', file); data.append('requestId', requestId);
  const { response, error } = await apiRequest({ method: 'POST', url: 'reimbursement-receipts', isToken: true, params: { eventId, reimbursementId }, data });
  if (error || !response) throw error || new Error('Unable to upload reimbursement receipt');
  return response.data?.data as ExpenseReceipt;
}
export async function archiveReimbursementReceipt(eventId: string, reimbursementId: string, receiptId: string) {
  const { response, error } = await apiRequest({ method: 'DELETE', url: `reimbursement-receipts/${encodeURIComponent(receiptId)}`, isToken: true, params: { eventId, reimbursementId } });
  if (error || !response) throw error || new Error('Unable to remove reimbursement receipt');
}
